import { render, staticRenderFns } from "./WalletActivities.vue?vue&type=template&id=8cf168ea&scoped=true&"
import script from "./WalletActivities.vue?vue&type=script&lang=js&"
export * from "./WalletActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf168ea",
  null
  
)

export default component.exports